export const ACTIVE_DAY = "activeDay" as const;
export const TIMESTAMP = "timestamp" as const;
export const CITY_LABEL = "cityLabel" as const;
export const CHOSEN_METRIC = "chosenMetric" as const;
export const PEAK_TIME = 14;
